import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockProps } from '../../defs/block';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { BalloonBoxBlockComponent } from './BalloonBoxBlockComponent';
import { BalloonBoxBlockProps } from './BalloonBoxBlock';

const BalloonBoxBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  BalloonBoxBlockComponent,
);
export type BalloonBoxBlockEntity = EntityType<typeof BalloonBoxBlockEntityDef>;

export function _spawnBalloonBoxBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: BlockProps,
  position: Vector2,
): BalloonBoxBlockEntity {
  // spawn base block
  const entity = _spawnBaseBlockEntity(
    BalloonBoxBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockBalloonBox: {
        props: props as BalloonBoxBlockProps,
        option: def.option,
      },
    },
  );

  // build scene
  entity.c.view2d.view.addChild(entity.c.blockBalloonBox.view);

  return entity;
}
